module.exports = __webpack_public_path__ + "static/media/AddEvent.2ff890b8.svg";